module.exports = __webpack_public_path__ + "img/728473_534C40_7BCEC8_7BB9B6-256px.b5c5a700.png";